export const UPDATE_TABLE_CONTEXT = 'UPDATE_TABLE_CONTEXT'
